import { useEffect, useState } from 'react';
import { trackView } from '@vfit/shared/data-access';
import { VfModal } from '@vfit/shared/components';
import {
  API,
  PAGES,
  openPopup,
  requireStaticImageAtomComponent,
  AppMobile,
} from '@vfit/shared/data-access';
import {
  CMS_CONFIG,
  getCurrentUserType,
  getSelectedOfferIds,
  handleFirstCharacterOfSentence,
  ICampaignResponse,
  ICoverageToolCongifg,
  IUserType,
  retrieveLockInOfferFromStorage,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { Button } from '@vfit/shared/atoms';
import { CoverageErrorType, IOfferingServiceabilityResponse } from '@vfit/shared/models';
import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { DEFAULT_ADDRESS, useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { IModalConfig } from './coverageToolMapCard.models';
import { ButtonDiv, ModalDescription, ModalTitle, ModalWrap } from './coverageToolMapCard.style';
import { getAddress } from '@vfit/consumer/components';
import { EditAddress } from '../CoverageToolOtpCard/coverageToolOtpCard.style';
import CoverageToolMap from './components/CoverageToolMap/coverageToolMap';
import CoverageToolMapCardTagging from './coverageToolMapCard.tagging';

const CoverageToolMapCard = ({
  handleGoNextSlide,
  handleGoPrevSlide,
  handleOnClose,
}: ICommonData) => {
  const [isOnFinish, setIsOnFinish] = useState<boolean>(false);
  const {
    isSuccess,
    address,
    product,
    isManual,
    isLoading,
    isError,
    errorCoverage,
    setSlidesGoBack,
    setAddress,
    setIsAddressConfirmed,
    setIsError,
    setIsLoading,
    setIsSuccess,
  } = useCoverageToolModalProvider();
  const { errorType } = errorCoverage;
  const INIT_MODAL_CONFIG: IModalConfig = {
    isOpen: false,
    title: '',
    description: '',
    firstActionLabel: '',
    firstAction: () => {
      return;
    },
    secondActionLabel: '',
    secondAction: () => {
      return;
    },
  };
  const [modalConfig, setModalConfig] = useState<IModalConfig>(INIT_MODAL_CONFIG);
  const isLoggedUser = getCurrentUserType() === IUserType.LOGGED_USER;

  const coverageToolConfig = useCmsConfig(
    CMS_CONFIG[PAGES.CONSUMER],
    API.CMS_GET_COVERAGE_TOOL_CONFIG
  ) as ICoverageToolCongifg;

  const checkLockInLoggedOfferingServiceAbility = () => {
    const offeringServiceabilitySaved = localStorage.getItem('offeringServiceability');
    const offeringServiceability: IOfferingServiceabilityResponse | undefined =
      !!offeringServiceabilitySaved &&
      offeringServiceabilitySaved !== 'undefined' &&
      JSON.parse(offeringServiceabilitySaved as string);
    const lockInOfferFound = localStorage.getItem('lockinOfferFound');
    const lockInOffer: ICampaignResponse = !!lockInOfferFound && JSON.parse(lockInOfferFound);
    const lockInProductOfferId = lockInOffer?.fixedBundle?.productOfferId;
    return offeringServiceability?.offeringServiceabilityItem?.find(
      (o) => o?.offering?.id == lockInProductOfferId
    );
  };

  const checkCoverageLockIn = (): boolean => {
    const campaignsData = localStorage.getItem('campaignsData');
    const campaignsDataSaved =
      !!campaignsData && campaignsData !== 'undefined' && JSON.parse(campaignsData as string);
    const offeringServiceabilitySaved = localStorage.getItem('offeringServiceability');
    const offeringServiceability: IOfferingServiceabilityResponse | boolean =
      !!offeringServiceabilitySaved && JSON.parse(offeringServiceabilitySaved as string);
    if (campaignsDataSaved && campaignsDataSaved?.length > 0 && offeringServiceability) {
      const lockInOfferFound = retrieveLockInOfferFromStorage();
      return !lockInOfferFound;
    }
    return false;
  };

  const onClickEditAddress = () => {
    setModalConfig({ ...INIT_MODAL_CONFIG });
    setTimeout(() => {
      setSlidesGoBack(isManual ? 2 : 1);
    }, 200);
  };

  const onClickCallMeNow = () => {
    if (product?.callMeNowHelp?.url) openPopup(product?.callMeNowHelp?.url);
  };

  const modalErrorNoCoverage = () => {
    const addressLocal = getAddress();
    const composedAddress = `${address?.street} ${address?.streetNumber} - ${address?.city}`;
    const koCoverageLabel = {
      title: coverageToolConfig?.coveragetool?.koCoverageTool?.title || '',
      description:
        coverageToolConfig?.coveragetool?.koCoverageTool?.description?.replace(
          'PLACEHOLDER',
          `${composedAddress}` || ''
        ) || '',
      buttonList: [
        {
          text: coverageToolConfig?.coveragetool?.koCoverageTool?.buttonEditAddress || '',
        },
        {
          text: coverageToolConfig?.coveragetool?.koCoverageTool?.buttonCallsYou || '',
        },
      ],
    };
    trackView({
      event_name: 'journey_end',
      event_label_track: 'no coverage',
      event_category: 'journey',
      page_type: 'ko',
      tracking_type: 'view',
      journey_name: 'verify lock-in',
      page_subsection: 'lock-in',
    });

    setModalConfig({
      isOpen: true,
      onCloseAction: handleOnClose,
      title: koCoverageLabel.title,
      ...(addressLocal?.displayedAddress && {
        subDesc: (
          <div>
            <h4>
              <b>Indirizzo</b>
            </h4>
            <p>{handleFirstCharacterOfSentence(addressLocal?.displayedAddress || '')}</p>
          </div>
        ),
      }),
      description: koCoverageLabel.description,
      firstActionLabel: koCoverageLabel?.buttonList?.[0]?.text,
      firstAction: onClickEditAddress,
      secondActionLabel: koCoverageLabel?.buttonList?.[1]?.text,
      secondAction: onClickCallMeNow,
    });
  };

  const goPrevSlide = () => {
    setAddress(DEFAULT_ADDRESS);
    setIsAddressConfirmed(false);
    setIsOnFinish(false);
    setIsError(false);
    setIsLoading(false);
    setIsSuccess(false);
    handleGoPrevSlide?.();
  };

  const goNextSlide = () => {
    const isApp = AppMobile.checkIsApp();
    if (product?.isLockInProduct && !isApp) {
      const { offerId: filterOfferId } = getSelectedOfferIds();
      if (!filterOfferId) {
        return modalErrorNoCoverage();
      }
      if (!isLoggedUser) {
        handleGoNextSlide?.();
      } else if (checkLockInLoggedOfferingServiceAbility()) {
        setIsOnFinish(true);
        handleGoNextSlide?.({}, true);
      } else if (checkCoverageLockIn() && isApp) {
        modalErrorNoCoverage();
      } else {
        trackView({
          event_name: 'journey_end',
          event_label_track: 'lock-in not available for logged user',
          event_category: 'journey',
          page_type: 'ko',
          tracking_type: 'view',
          journey_name: 'verify lock-in',
          page_subsection: 'lock-in',
        });
        setIsOnFinish(true);
        handleGoNextSlide?.({}, true);
      }
    } else {
      setIsOnFinish(true);
      handleGoNextSlide?.({}, true);
    }
  };

  const confirmAddress = () => {
    setIsAddressConfirmed(true);
  };

  const handleOnCloseError = () => {
    switch (errorType) {
      case CoverageErrorType.R2_LOGGED:
        window.location.href = '/';
        break;
      default:
        goPrevSlide();
    }
  };

  useEffect(() => {
    if (isSuccess) {
      goNextSlide();
    }
  }, [isSuccess]);

  return (
    <>
      <CoverageToolMapCardTagging />
      <CoverageToolMap
        onConfirm={confirmAddress}
        onEditAddress={goPrevSlide}
        address={address}
        isLoading={isLoading || (isError && !product?.isLockInProduct) || isOnFinish}
        lottieFile={
          product?.loaders?.coverageTool &&
          requireStaticImageAtomComponent(product.loaders.coverageTool).src
        }
        errorType={errorType}
        isError={isError && !product?.isLockInProduct}
        onCloseError={handleOnCloseError}
        product={product || undefined}
      />
      <VfModal
        isOpen={modalConfig.isOpen}
        handleClose={() => {
          setModalConfig({ ...INIT_MODAL_CONFIG });
          if (modalConfig.onCloseAction) {
            modalConfig.onCloseAction();
          }
        }}
      >
        <ModalWrap>
          <div>
            <ModalTitle>{modalConfig.title}</ModalTitle>
            {modalConfig?.description && (
              <ModalDescription dangerouslySetInnerHTML={{ __html: modalConfig.description }} />
            )}
            {modalConfig.subDesc && (
              <div>
                {modalConfig.subDesc}
                <EditAddress onClick={modalConfig.firstAction}>Modifica indirizzo</EditAddress>
              </div>
            )}
          </div>
          <ButtonDiv>
            {!modalConfig.subDesc && modalConfig.firstActionLabel && modalConfig.firstAction && (
              <Button
                onClick={modalConfig.firstAction}
                variant={'primary'}
                name="action_first_coverageToolMap"
              >
                {modalConfig.firstActionLabel}
              </Button>
            )}

            {modalConfig.secondActionLabel && modalConfig.secondAction && (
              <Button
                variant={'secondary'}
                onClick={modalConfig.secondAction}
                name="action_second_coverageToolMap"
              >
                {modalConfig.secondActionLabel}
              </Button>
            )}
          </ButtonDiv>
        </ModalWrap>
      </VfModal>
    </>
  );
};

export default CoverageToolMapCard;
